import { SettingsAPI } from "@/utils/generated/api-public";
import { defineStore } from "pinia";
import { nanoid } from "nanoid";
import { ofetch } from "ofetch";

export const useSettingsStore = defineStore("settings", () => {
  const sid = ref(nanoid(5));
  const settings = SettingsAPI.getSettings.ref();

  async function loadSettings() {
    settings.value = await ofetch("/n/api/public/settings", {
      retryDelay: 600,
      retry: 5,
      headers: { Sid: sid.value },
    });
    return settings.value;
  }

  return {
    settings,
    loadSettings,
    sid,
  };
});
